const flag = (key: string) => import.meta.env[key] === 'true';

export const FEATURES = {
  feed:        true,
  directory:   true,
  community:   true,
  messages:    true,
  learnKhmer:  true,
  events:      flag('VITE_FEATURE_EVENTS'),
  ventures:    flag('VITE_FEATURE_VENTURES'),
  jobs:        flag('VITE_FEATURE_JOBS'),
  mentorship:  flag('VITE_FEATURE_MENTORSHIP'),
} as const;
